import { css } from "styled-components";

export const POINTER_HOVER_MEDIA = "(hover: hover) and (pointer: fine)";

export const pointerHover = (styles) => css`
  @media ${POINTER_HOVER_MEDIA} {
    ${styles}
  }
`;
